import {
  abTestEvents,
  aiRewriteEvents,
  apiEvents,
  audioDownloadEvents,
  bannerSidebarEvents,
  boosterEvents,
  demoProjectsTrial,
  feedbackEvents,
  lipSyncEvents,
  miscEvents,
  multilanguageEvents,
  onboardingEvents,
  paywallEvents,
  platformEvents,
  pricingEvents,
  projectEvents,
  sidebarEvents,
  signInEvents,
  signUpEvents,
  srtDownloadEvents,
  srtEditorEvents,
  srtUploadEvents,
  subscriptionEvents,
  subtitlesBurningEvents,
  teamspacesEvents,
  trialShareEvents,
  uploadVideoEvents,
  videoPlayerEvents,
  voiceEvents,
} from './events';
import { advancedToolsEvents } from './events/advancedToolsEvents';
import { glossaryEvents } from './events/glossaryEvents';
import { leadSurveyEvents } from './events/leadSurveyEvents';
import { recordingAuthEvents } from './events/recordingAuthEvents';
import { recordingFeedbackBonusEvents } from './events/recordingFeedbackBonusEvents';
import { recordingPlatformLockEvents } from './events/recordingPlatformLockEvents';
import { recordingShareEvents } from './events/recordingShareEvents';
import { recordingSurveyEvents } from './events/recordingSurveyEvents';
import { screenRecordEvents } from './events/screenRecordEvents';
import { userPromptingEvents } from './events/userPromptingEvents';
import { trackEvent } from './mixpanelMethods';

export const EVENTS = [
  ...boosterEvents,
  ...pricingEvents,
  ...paywallEvents,
  ...onboardingEvents,
  ...srtUploadEvents,
  ...apiEvents,
  ...aiRewriteEvents,
  ...multilanguageEvents,
  ...srtEditorEvents,
  ...subscriptionEvents,
  ...lipSyncEvents,
  ...subtitlesBurningEvents,
  ...platformEvents,
  ...signInEvents,
  ...signUpEvents,
  ...uploadVideoEvents,
  ...videoPlayerEvents,
  ...feedbackEvents,
  ...miscEvents,
  ...voiceEvents,
  ...audioDownloadEvents,
  ...srtDownloadEvents,
  ...glossaryEvents,
  ...bannerSidebarEvents,
  ...abTestEvents,
  ...projectEvents,
  ...sidebarEvents,
  ...demoProjectsTrial,
  ...teamspacesEvents,
  ...userPromptingEvents,
  ...trialShareEvents,
  ...advancedToolsEvents,
  ...screenRecordEvents,
  ...recordingAuthEvents,
  ...recordingPlatformLockEvents,
  ...recordingShareEvents,
  ...recordingSurveyEvents,
  ...leadSurveyEvents,
  ...recordingFeedbackBonusEvents,
];

type EventNames = (typeof EVENTS)[number]['eventName'];

type EventPayload = {
  [key: string]: boolean | number | string | undefined;
};

type Event = {
  [key in EventNames]: (payload?: EventPayload) => void;
};

type MixpanelEvent = {
  eventName: EventNames;
  shouldSendRaskTTSData?: boolean;
  shouldSendSubscriptionData?: boolean;
};

export const getEvents = (events: MixpanelEvent[]) => {
  return events.reduce((acc, event) => {
    const { eventName, shouldSendRaskTTSData, shouldSendSubscriptionData } = event;

    return {
      ...acc,
      [eventName]: (properties?: EventPayload) =>
        trackEvent({
          eventName,
          metadata: { shouldSendRaskTTSData, shouldSendSubscriptionData },
          properties,
        }),
    };
  }, {} as Event);
};

export const MixpanelEvents = getEvents(EVENTS);

export {
  initMixpanel,
  setMixpanelSubscriptionProfile,
  setMixpanelUser,
  setMixpanelUserProperty,
  shutdownMixpanel,
} from './mixpanelMethods';

export { resetMixpanelProps, useMixpanelPropsStore } from './useMixpanelPropsStore';
